import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setError("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0B0A0C]">
      <div className="w-full max-w-md glass border border-[#D4AF37]/20 rounded-2xl p-8 sm:p-10">
        <span className="font-display text-2xl gold-text tracking-[0.15em] block text-center">AFRODITE</span>
        <p className="overline text-center mt-2 mb-8">Recupero Password</p>
        {sent ? (
          <p className="text-sm text-[#A39E9B] text-center leading-relaxed">
            Se l'email è registrata, riceverai un link per reimpostare la password.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            {error && <div className="p-3 rounded-lg bg-[#7A1426]/25 border border-[#7A1426] text-sm text-[#F3E5AB]">{error}</div>}
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email-input" placeholder="La tua email"
              className="w-full px-4 py-3 rounded-lg bg-[#0B0A0C] border border-[#D4AF37]/20 text-[#FBF8F5] focus:border-[#D4AF37] outline-none" />
            <button type="submit" data-testid="forgot-submit-btn"
              className="w-full py-3.5 rounded-full bg-[#7A1426] hover:bg-[#941B30] text-[#FBF8F5] font-semibold border border-[#D4AF37]/30">
              Invia link di reset
            </button>
          </form>
        )}
        <div className="mt-6 text-center">
          <Link to="/admin" className="text-xs text-[#A39E9B] hover:text-[#D4AF37]">Torna al login</Link>
        </div>
      </div>
    </div>
  );
}
